import { createStore } from '@store/index';
import type { Store } from '@store/store/store';
import type { StoreOptions } from '@store/types/storeOptions';

export const cartCountStore: Store = createStore<StoreOptions>({
    name: 'cartCount',
    initialValue: 0,
    type: Number
});
